import { render, staticRenderFns } from "./DataAnomalyFlag.vue?vue&type=template&id=67a4ce5d&scoped=true"
import script from "./DataAnomalyFlag.vue?vue&type=script&lang=js"
export * from "./DataAnomalyFlag.vue?vue&type=script&lang=js"
import style0 from "./DataAnomalyFlag.vue?vue&type=style&index=0&id=67a4ce5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a4ce5d",
  null
  
)

export default component.exports